export interface IReligion {
  id: number;
  religion: string;
}

export interface IOccupation {
  id: number;
  name: string;
}

export interface IBankBranch {
  id: number;
  brancH_CODE: string;
  branch: string;
  state: string;
}

export interface IIndustry {
  id: number;
  name: string;
}

export interface IMeansOfIdentification {
  id: number;
  value: string;
  text: string;
}

export interface IEmploymentInfo {
  id: number;
  name: string;
}

export interface IAccountMandate {
  id: number;
  mandate: string;
}

export interface Icurrency {
  id: number;
  currencY_CODE: number;
  brieF_DESC_ENG: string;
  lonG_DESC_ENG: string;
  gL_CODE: string;
}

export enum ICurrencyAccountType {
  DOM_SAVINGS = "DomSavings",
  DOM_CURRENT = "DomCurrent",
  CORPORATE = "Corporate",
}

export interface ICountry {
  id: number;
  countrY_CODE: string;
  brieF_DESC_ENG: string;
  lonG_DESC_ENG: string;
}

export interface ISocialMediaPlatform {
  id: number;
  name: string;
}

export interface IRelationship {}

export interface IBVNValidation {
  isSuccess: boolean;
  responseMessage: string;
  firstName: string;
  lastName: string;
  middleName: string;
  isFlagged: boolean;
  phoneNumber: string;
  gender: string;
  dateOfBirth: string;
}

export interface ININValidationResponse {
  id: string;
  message: string;
  data: {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    email: string;
    dateOfBirth: string;
    mobile: string;
    gender: string;
    country: string;
    createdAt: string;
    address: string;
  };
  success: boolean;
  dateOfBirth: string;
}

export type BVNNINValidationResponse = Partial<
  ININValidationResponse & IBVNValidation
>;

export interface IValidateOtpPayload {
  firstName: string;
  lastName: string;
  middleName: string;
  phoneNumber: string;
  otp: string;
  bvn: string;
}
export interface IValidateOtpResponse {
  UserEmail: null;
  originalUserName: null;
  accessToken: string;
  refreshToken: string;
  message: string;
  UserDetails: null;
  isSuccess: boolean;
  accessTokenExpirationTime: "";
  refreshTokenExpirationTime: "";
}

export interface RequestOtpPayload {
  voiceOtp?: boolean;
  whatsapOtp?: boolean;
  emailAddress?: string;
  phoneNumber: string;
  customerName: string;
  bvn: string;
}
export interface SubmitSwiftDocsPayload {
  id: number;
  signatureUrl: string;
  imageUrl: string;
  debitCardValueAddedService: boolean;
  accountTypecode: string;
  accountTypeName: string;
}

export interface FileUploadPayload {
  postedFilebase64: string;
  documentName: string;
  filetype: string;
}
export interface FileUploadResponse<T = any> {
  id: string;
  isSuccess: boolean;
  message: string;
  otpExpiry?: string;
  obj?: T;
}

export type DomDocUploadResponse = FileUploadResponse<
  UploadRegularDocsResponseObj[]
>;
export interface ValidateNINPayload {
  id: string;
  isSubjectConsent: boolean;
  phoneNumber: string;
  bvnPhoneNumber: string;
  bvnFirstName: string;
  bvnLastName: string;
  bvnMiddleName: string;
  bvnDateOfBirth: string;
  bvnGender: string;
  bvn: string;
}

export interface LogLivenessPayload {
  name: string;
  bvn: string;
  dateOfBirth: string;
  isSuccess: boolean;
}

interface ValidateIdentityPayload {
  bvn: string;
  nin: string;
  dateOfBirth: string;
  minorDateOfBirth: string;
  isUpgradeValidation: boolean;
}

export type ValidateIdentityType = Partial<ValidateIdentityPayload>;

export type BvnFaceMatchPayload = FormData;

export interface FaceMatchResponse<T, O> {
  isSuccess: boolean;
  responseMessage: string;
  bvnData: T;
  faceMatchData: O;
}

export interface UpdateDetailsResponseObj {
  firstName: string;
  middleName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
  gender: "M" | "F";
  cifNo: null;
  dob: string;
  houseNumber: string;
  streetName: string;
  areaState: string;
  nearestBustopLandmark: string;
  address: string;
  religion: number;
  occupation: number;
  referralCode: null;
  signatureUrl: null;
  imageUrl: null;
  branchOfDomiciliation: number;
  smsAlertValueAddedService: boolean;
  emailAlertValueAddedService: boolean;
  debitCardValueAddedService: boolean;
  isCompleted: boolean;
  bvn: string;
  accountNumber: null;
  refereeFormUrl: null;
  isSentToIxpress: boolean;
  socialMediaId: number;
  socialMediaHandle: null;
  termsCondition: boolean;
  nin?: string;
  town: string;
  localGovernment: string;
  debitCardDeliveryAddress: null;
  nextOfKin: string;
  relationshipOfNextOfKin: string;
  employmentInformation: string;
  upgradedToTier2: boolean;
  id: number;
  createdAt: string;
  updatedAt: null;
}

export type UpdateDetailsResponse =
  FileUploadResponse<UpdateDetailsResponseObj>;

export interface UploadDocsObj {
  responseCode: string;
  responseMessage: string;
  bvn: string;
  currency: string;
  cifNo: string;
}

export type UploadSwiftDocsResponse =
  FileUploadResponse<UploadRegularDocsResponseObj>;

export interface RegularSavingsDocsPayload {
  id: number;
  signatureUrl: string;
  imageUrl: string;
  frontPageIdUrl: string;
  debitCardValueAddedService: boolean;
  accountTypecode: string;
  accountTypeName: string;
  utilityBill: string;
  identityCardType: number;
  idCardNumber: string;
  issueDate: string;
  expiryDate: string;
}
export interface GuardianDetailsPayload {
  gender: string;
  firstName: string;
  middleName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
  dob: string;
  houseNumber: string;
  streetName: string;
  areaState: string;
  nearestBustopLandmark: string;
  address: string;
  referralCode: string;
  bvn: string;
  socialMediaId: number;
  socialMediaHandle: string;
  town: string;
  localGovernment: string;
  termsCondition: boolean;
  relationship: string;
  title: string;
  religion: number;
  country: number;
  maidenName: string;
  branchOfDomiciliation: number;
}
export interface MinorDetailsPayload {
  minorFirstName: string;
  minorMiddleName: string;
  minorLastName: string;
  minorDob: string;
  minorFullName: string;
  minorEmail: string;
  minorNIN: string;
  minorPhoneNumber: string;
  minorReligion: number;
  minorHouseNumber: string;
  minorStreetName: string;
  minorNearestBusStop: string;
  minorLGA: string;
  minorState: string;
  minorAddress: string;
  minorBirthCertificate: string;
  minorPassport: string;
}

export type MinorDetailsResponse = FileUploadResponse<
  GuardianDetailsPayload & MinorDetailsPayload
>;

export type MinorDetailsType = Partial<
  MinorDetailsPayload & GuardianDetailsPayload
>;

export type CountriesResponse = {
  id: number;
  countrY_CODE: string;
  brieF_DESC_ENG: string;
  lonG_DESC_ENG: string;
};

export interface MinorDocsPayload {
  id: number;
  signatureUrl: string;
  imageUrl: string;
  minorIdentityUrl: string;
  accountTypecode: string;
  accountTypeName: string;
  utilityBill: string;
  handoverAccount: boolean;
}

export interface DomDocsUploadPayload extends RegularSavingsDocsPayload {
  currencyOfAccountUSD: string;
  currencyOfAccountGBP: string;
  currencyOfAccountEURO: string;
}

export interface RegularSavingsDetailsPayload {
  firstName: string;
  middleName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
  dob: string;
  gender: string;
  houseNumber: string;
  streetName: string;
  areaState: string;
  nearestBustopLandmark: string;
  address: string;
  religion: number;
  selfEmployementInformation: number;
  occupation: number;
  nameOfNextOfKin: string;
  referralCode: string;
  bvn: string;
  socialMediaId: number;
  socialMediaHandle: string;
  town: string;
  localGovernment: string;
  branchOfDomiciliation: number;
  termsCondition: boolean;
  relationshipOfNextOfKin: string;
}

export interface UploadRegularDocsResponseObj {
  responseCode: string;
  responseMessage: string;
  accountNo: string;
  bvn: null;
  currency: string;
  cifNo: null;
}

interface Timezone {
  zoneName: string;
  gmtOffset: number;
  gmtOffsetName: string;
  abbreviation: string;
  tzName: string;
}

interface City {
  id: number;
  name: string;
  latitude: string;
  longitude: string;
}
export interface State {
  id: number;
  name: string;
  state_code: null;
  latitude: string;
  longitude: string;
  type: string;
  cities: City[];
}
export interface CountryDTO {
  id: number;
  name: string;
  iso3: string;
  iso2: string;
  numeric_code: string;
  phonecode: string;
  capital: string;
  currency: string;
  currency_name: string;
  currency_symbol: string;
  tld: string;
  native: string;
  region: string;
  region_id: number;
  subregion: string;
  subregion_id: number;
  nationality: string;
  timezones: Timezone[];
  latitude: string;
  longitude: string;
  emoji: string;
  emojiU: string;
  states: State[];
}

export interface AvailableChannelsResponse {
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
  data: {
    availableOtps: Array<"VoiceOtp" | "WhatsappOtp" | "USSD" | "BvnFaceMatch">;
  };
}

export interface UpdateCampaignDetailsPayload {
  accountNumber: string;
  acquisitionAttribId: string;
  acquisitionChannel: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  gclid: string;
  fbclid: string;
  ttclid: string;
  twclid: string;
  snapclid: string;
  msclkid: string;
  firstTouch: string;
}

export interface YouVerifyTokenSessionResponse {
  isSuccess: boolean;
  responseMessage: string;
  sessionResponse: {
    success: boolean;
    statusCode: number;
    message: string;
    data: {
      sessionId: string;
      expiresAt: string;
      status: string;
    };
    links: [];
  };
  authTokenResponse: {
    success: boolean;
    statusCode: number;
    message: string;
    data: {
      authToken: string;
      sessionId: string;
    };
    links: [];
  };
}

export interface YouVerifyTokenSessionRequest {
  publicMerchantID: string;
}

export interface HypervergeTokenResponse {
  isSuccess: boolean;
  responseMessage: string;
  data: {
    status: string;
    statusCode: number;
    result: {
      authToken: string;
    };
  };
}

export interface GetFacialsChannelsResponse {
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
  data: { availableFacials: Array<"Hyperverge" | "YouVerify"> };
}

export interface YouVerifySuccessResponse {
  parentId: string;
  businessId: string;
  method: string;
  requestedAt: string;
  components: Array<string>;
  faceImage: string;
  livenessClip: string;
  passed: boolean;
  country: string;
  metadata: Record<string, any>;
  isConsent: boolean;
  sessionId: string;
  createdAt: string;
  lastModifiedAt: string;
  _createdAt: string;
  _lastModifiedAt: string;
  id: string;
}

export interface YouVerifyErrorResponse {
  faceImage: string;
  passed: boolean;
  metadata: Record<string, any>;
  error: {
    key: string | "VALIDATION_ERROR";
    message: string;
  };
}

export interface CurrentDetailsPayload {
  firstName: string;
  secondName: string;
  lastName: string;
  dateOfBirth: string;
  phoneNumber: string;
  emailAddress: string;
  gender: string;
  houseNumber: string;
  streetName: string;
  areaState: string;
  nearestBustopLandmark: string;
  address: string;
  religion: string;
  selfEmployementInformation: number;
  occupation: number;
  nextOfKin: string;
  referralCode: string;
  bvn: string;
  socialMediaId: number;
  socialMediaHandle: string;
  town: string;
  localGovernment: string;
  termsCondition: boolean;
  branchOfDomiciliation: number;
  relationshipOfNextOfKin: string;
}

export interface LivePhotoCardProps {
  label: string;
  hideLabel: boolean;
  required: boolean;
  getFileUrl: (url: string) => void;
}

export interface AllAccountNumberByTINResponse {
  hasAccount: boolean;
  responseMessage: string;
  isSuccess: boolean;
  token: string | null;
}

export interface VerifyBusinessNumberRequest {
  registrationNumber: string;
}

export interface VerifyBusinessNumberResponse {
  success: boolean;
  statusCode: number;
  message: string;
  accessToken: string;
  refreshToken: {
    id: string;
    username: string;
    tokenString: string;
    expireAt: string;
  };
  accessTokenExpirationTime: string;
  refreshTokenExpirationTime: string;
  businessDetails: {
    name: string;
    registrationNumber: string;
    taxId: string;
  };
}

export interface TINValidationResponse {
  userEmail: string | null;
  originalUserName: string | null;
  accessToken: string;
  refreshToken: string;
  message: string;
  userDetails: {
    status: boolean;
    message: string;
    data: {
      tin: string;
      jtbtin: string | null;
      taxPayerName: string;
      address: string;
      taxOfficeID: string;
      taxOfficeName: string;
      taxPayerType: string;
      rcNumber: string;
      email: string;
      phone: string;
    };
  };
  isSuccess: boolean | null;
  accessTokenExpirationTime: string;
  refreshTokenExpirationTime: string;
}

export interface ConvertImageToBase64Response {
  success: boolean;
  statusCode: number;
  message: string;
  base64: string;
  contentType: string;
  dataUrl: string;
}
